import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@api/base-services-axios-rtx";

import { AgencyEndpoints } from "@/shared/models/endpoints/agency.endpoint";
import { IAgenciesPublicResponse } from "@/shared/models/interfaces/response/agencies/public/agencies-list.response";
import { createQuery } from "@/shared/helpers/create-query.helper";

export const AgencyQueryServices = createApi({
  reducerPath: "agency-services",
  baseQuery: axiosBaseQuery(),

  endpoints: builder => ({
    getAgenciesPublic: builder.mutation({
      query: (values: IGetAgenciesPublicValues) => ({
        url:
          AgencyEndpoints.agencyPrivateList +
          createQuery({ ...values.filters, ['search']: values.filters.q }),
        method: "GET"
      }),
      transformResponse: (response: IAgenciesPublicResponse, meta, arg) =>
        response.data
    })
  })
});

export const { useGetAgenciesPublicMutation } = AgencyQueryServices;

export interface IGetAgenciesPublicValues {
  filters: IGetAgenciesPublicValuesFilters;
}

export interface IGetAgenciesPublicValuesFilters {
  q?: string;
}
